module.exports = __webpack_public_path__ + "static/media/plusMobile.4f654e47.svg";